/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  Strucutre:
          url     => router path
          name    => name to display in sidebar
          slug    => router path name
          icon    => Feather Icon component/icon name
          tag     => text to display on badge
          tagColor  => class to apply on badge element
          i18n    => Internationalization
          submenu   => submenu of current item (current item will become dropdown )
                NOTE: Submenu don't have any icon(you can add icon if u want to display)
          isDisabled  => disable sidebar item/group
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/product-backlog',
    name: "Backlog de produtos",
    slug: "product-backlog",
    icon: "CheckCircleIcon",
    i18n: "product-backlog",
  },
  
  {
    url: '/operations',
    name: "Operações",
    slug: "operations",
    icon: "GitCommitIcon",
    i18n: "operations",
    submenu: [
      {
        url: "/manage-jobs",
        name: "Gerenciar Jobs",
        slug: "manage-jobs",
        i18n: "manage-jobs"
      },
    ]
  },
  {
    url: '/security',
    name: "Segurança",
    slug: "security",
    icon: "ShieldIcon",
    i18n: "security",
    submenu: [
      {
        url: "/backup",
        name: "Backup",
        slug: "backup",
        i18n: "backup"
      },
      {
        url: "/user-register",
        name: "Cadastro de usuário",
        slug: "user-register",
        i18n: "user-register"
      },
      {
        url: "/manage-permissions",
        name: "Gerenciar permissões",
        slug: "manage-permissions",
        i18n: "manage-permissions"
      },
      {
        url: "/systems-list",
        name: "Lista de sistemas",
        slug: "systems-list",
        i18n: "systems-list"
      },
    ]
  },
  
]
